<template>
  <div class="nuevos-ingresos-shell ui-module-fade-in-up">
    <v-tabs class="mb-3" v-model="selectedTab" color="secondary">
      <v-tab class="font-weight-bold">Nuevos ingresos</v-tab>
      <v-tab class="font-weight-bold">Aspirantes reclutados como policías</v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab" class="transparent">
      <v-tab-item key="1" eager>
        <NuevosIngresosTabContent />
      </v-tab-item>
      <v-tab-item key="2" eager>
        <AspirantesConvertidosPoliciaTabContent />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import NuevosIngresosTabContent from '@/views/enlace/tab-content/NuevosIngresosTabContent.vue'
import AspirantesConvertidosPoliciaTabContent from '@/views/enlace/tab-content/AspirantesConvertidosPoliciaTabContent.vue'

export default {
  components: {
    NuevosIngresosTabContent,
    AspirantesConvertidosPoliciaTabContent,
  },

  data() {
    return {
      selectedTab: 0,
    }
  },
}
</script>

<style scoped>
.nuevos-ingresos-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}
</style>
